import { useRoutes } from "react-router-dom";
import QualityPlanChecklistExecution from "./component/qualityPlanChecklistExecution";
import QualityPlanChecklistExecutionForm from "./component/qualityPlanChecklistExecutionForm";

const QualityChecklistExecutionIndex = () => {
  const router = useRoutes([
    {
      index: true,
      element: <QualityPlanChecklistExecution />,
    },
    {
      path: "add", // ✅ relative instead of absolute
      element: <QualityPlanChecklistExecutionForm />,
    },
    {
      path: "edit/:id",
      element: <QualityPlanChecklistExecutionForm mode="edit" />,
    },
    {
      path: "view/:id",
      element: <QualityPlanChecklistExecutionForm mode="view" />,
    },
  ]);
  return <div>{router}</div>;
};

export default QualityChecklistExecutionIndex;
